module.exports = __webpack_public_path__ + "static/saltmarsh-header-86ac7f7cb1252bf7fb2d760818aef196.jpg";